import { createDomain } from 'effector';

import { type Answers } from 'types/zod/answers';
import { type Document } from 'types/zod/document';
import { type DocumentTypeCode } from 'types/zod/document-type-code';
import { type GiftTrustItem } from 'types/zod/gift-trust-item';
import { type Question } from 'types/zod/question';
import { type QuestionnaireInstance } from 'types/zod/questionnaire-instance';

const domain = createDomain('gift-trusts');

type QInstanceId = QuestionnaireInstance['questionnaire_instance_id'];

const $$giftTrust = {
    $qInstances: domain.store<QuestionnaireInstance[]>([]),
    $answers: domain.store<Record<QInstanceId, Answers | null>>({}),
    $questionnaire: domain.store<Question | null>(null),
    $giftTrustItems: domain.store<Record<QInstanceId, GiftTrustItem[]>>([]),
    $documents: domain.store<Record<QInstanceId, Document[]>>({}),
    $isPayed: domain.store<Record<QInstanceId, boolean>>({}),
    $jobs: domain.store<{ qInstanceId: QInstanceId; giftTrustItemId: GiftTrustItem['id']; job_id?: number }[]>([]),

    removeGiftItem: domain.event<{ qInstanceId: QInstanceId; giftTrustItemId: GiftTrustItem['id'] }>(),

    createNewInstanceFx: domain.effect<void, QuestionnaireInstance>(),
    getAnswersForOneInstanceFx: domain.effect<QInstanceId, void>(),
    getAnswersForAllInstancesFx: domain.effect<QInstanceId[], void>(),
    isPaymentOkBulkFx: domain.effect<QInstanceId[], { result: boolean }[]>(),
    updateAnswersFx: domain.effect<{ qInstanceId: QInstanceId; answers: Answers }, void>(),
    setIsSignedFx: domain.effect<{ qInstanceId: QInstanceId; answers: Answers }, Answers>(),
    generateLetterFx: domain.effect<{ qInstanceId: QInstanceId; answers: Answers }, void>(),
    generateGiftItemFx: domain.effect<
        { qInstanceId: QInstanceId; giftTrustItemId: GiftTrustItem['id'] },
        {
            job_id: number;
            created_docs: Record<string, DocumentTypeCode>;
        }
    >(),
};

export default $$giftTrust;
